<span class="flex font-archivo justify-center items-center gap-1 font-medium capitalize whitespace-nowrap"
      [ngClass]="[sizes[size], variants[variant], radii[radius], disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']"
      [attr.aria-disabled]="disabled"
      (click)="!disabled && onClick.emit()"
      (keydown.enter)="!disabled && onClick.emit()">
    <svg *ngIf="isDot" class="h-2 w-2" [ngClass]="[variants[variant]]" fill="currentColor"
        viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3" />
    </svg>
    {{ label }}
    <button *ngIf="showActionIcon" tabindex="-1" type="button" [disabled]="disabled" (click)="!disabled && onAction.emit(); $event.stopPropagation()" class="flex items-center justify-center">
        <svg class="h-4 w-4" [ngClass]="removeIconColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve" stroke="currentColor" fill="none">
            <circle stroke-width="3" stroke-miterlimit="10" cx="16" cy="16" r="12"/>
            <path stroke-width="3" stroke-miterlimit="10" d="m11.5 11.5 9 9m0-9-9 9"/>
        </svg>
    </button>
</span>